/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_GENERATE_CLIENT_REQUEST,
  FETCH_GENERATE_CLIENT_SUCCESS,
  FETCH_GENERATE_CLIENT_FAILURE,
} from "./GenerateClientTypes";

const initialState = {
  loading: false,
  generalClientIds: {},
  error: "",
};

const GeneralClientReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GENERATE_CLIENT_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_GENERATE_CLIENT_SUCCESS:
      return {
        loading: false,
        generalClientIds: action.payload,
        error: "",
      };
    case FETCH_GENERATE_CLIENT_FAILURE:
      return {
        loading: false,
        generalClientIds: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export default GeneralClientReducer;
